<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="600px"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="100px" :rules="rules">
          <el-form-item label="岗位名称" required>
            <el-input
              v-model="form.RoleName"
              placeholder="请输入用户编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="岗位权限" required>
            <el-tree
              :data="TreeData"
              show-checkbox
              node-key="Id"
              :default-expand-all="true"
              :props="defaultProps"
              ref="dialogTree"
              @check-change="handleCheckChange"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span
                  v-if="data.children && data.children.length > 0"
                  style="font-weight: 1000; font-size: 16px"
                >
                  <i class="el-icon-menu" style="font-size: 18px"></i>&nbsp;{{
                    node.label
                  }}</span
                >
                <span v-if="!data.children"> {{ node.label }}</span>
                <!-- <span> {{ data }}</span> -->
              </span>
            </el-tree>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      loading: false,
      form: {
        RoleName: '',
        Actions: [],
      },
      rules: {
        RoleName: [
          { required: true, message: '请输入岗位名称', trigger: 'blur' },
        ],
        Actions: [
          { required: true, message: '请选择岗位权限', trigger: 'change' },
        ],
      },
      drawer: false,
      TreeData: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      EquipmentClassificationIds: [],
    }
  },
  props: {},
  components: {},
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate)

      console.log(this.$refs.dialogTree.getCheckedKeys())
      this.form.Actions = this.$refs.dialogTree.getCheckedKeys()
    },
    getTreeData() {
      this.$http
        .post('/Base_Manage/Base_Action/GetActionTreeList', {})
        .then((resJson) => {
          if (resJson.Success) {
            this.TreeData = resJson.Data
          }
        })
    },
    handleSubmit() {
      console.log(this.form.Actions.length)
      if (this.form.Actions.length > 0 && this.form.RoleName) {
        this.loading = true
        this.$http
          .post('/Base_Manage/Base_Role/SaveData', this.form)
          .then((res) => {
            this.loading = false
            if (res.Success) {
              this.$notify.success('保存成功')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(res.Msg)
            }
          })
      } else {
        this.$notify.error('请检查输入项')
      }
      console.log(this.form)
    },
    openForm(title, row = {}) {
      this.drawer = true
      this.getTreeData()
      this.form = {
        RoleName: '',
        Actions: [],
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.$refs.dialogTree.setCheckedKeys([])
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base_Manage/Base_Role/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data
            this.$nextTick(() => {
              this.$refs.dialogTree.setCheckedKeys(this.form.Actions)
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  overflow-y: auto;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .el-tree-node__content {
  height: 30px;
}
</style>
